export default "__VITE_ASSET__C8KtH4Qs__"